<template>
  <div class="s-overlap-strips s-wizard">
    <div class="s-overlap-strips__head">
      <div class="s-overlap-strips__head__conts">
        <div class="s-overlap-strips__row">
          <div class="s-wizard__results__header">
            <h1>{{ results.resultTitle }}</h1>
            <img
              v-if="results.resultImg"
              :src="results.resultImg.url"
              :alt="results.resultImg.alt" />
          </div>
        </div>
      </div>
    </div>

    <template v-if="results">
      <template v-for="(data, index) in results.results" :key="index">
        <WizardResultsProfile v-if="data.type === 'profile'" :data="data" />

        <WizardResultsPlan v-if="data.type === 'plan'" :data="data" />

        <WizardResultsSuggestion
          v-if="data.type === 'suggestions'"
          :data="data" />
      </template>
    </template>

    <div class="s-overlap-strips__strip s-overlap-strips__strip--footer">
      <div class="s-overlap-strips__head__conts">
        <div class="s-overlap-strips__row">
          <div class="s-wizard__results__footer">
            <div class="s-wizard__results__footer__left">
              <div class="title">{{ dictionary.resultsSendResultsTitle }}</div>
              <div
                class="disclaimer d-lg-block d-none"
                v-html="dictionary.resultsSendResultsDisclaimer"></div>
            </div>
            <form
              class="s-wizard__results__footer__right"
              @submit.prevent="onSubmitForm">
              <Loader v-if="isLoading" display="absolute"></Loader>
              <Alert
                v-if="errorMsgs.length"
                type="danger"
                :messages="errorMsgs" />
              <Alert
                v-if="showResponse"
                type="success"
                :messages="[dictionary.responseSuccessText]" />

              <div class="email">
                <div>
                  <input
                    v-model.trim="email"
                    type="email"
                    placeholder="Email"
                    :class="{ 'has-error': v$.email.$error }"
                    class="form-control form-control--white"
                    @blur="v$.email.$touch" />
                  <div v-if="v$.email.$error">
                    <div v-if="v$.email.required.$invalid" class="error">
                      {{ dictionary.resultsSendResultsEmailRequired }}
                    </div>
                    <div v-if="v$.email.email.$invalid" class="error">
                      {{ dictionary.resultsSendResultsEmailRegex }}
                    </div>
                  </div>
                </div>
                <button type="submit" class="footer__newsletter__cta">
                  <span>{{ dictionary.resultsSendResultsButtonLabel }}</span>
                </button>
              </div>
              <div class="checks">
                <div class="check">
                  <input
                    id="terms"
                    v-model="terms"
                    type="checkbox"
                    :class="{ 'has-error': v$.terms.$error }"
                    @blur="v$.terms.$touch" />
                  <div>
                    <label
                      for="terms"
                      v-html="dictionary.resultsSendResultsTerms"></label>
                    <div v-if="v$.terms.$error">
                      <div v-if="v$.terms.sameAs.$invalid" class="error">
                        {{ dictionary.resultsSendResultsEmailRequired }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="check">
                  <input
                    id="newsletter"
                    v-model="subscription"
                    type="checkbox"
                    name="agree"
                    value="newsletter" />
                  <label
                    for="newsletter"
                    v-html="dictionary.resultsSendResultsNewsletter"></label>
                </div>
              </div>
            </form>
            <div
              class="disclaimer d-block d-lg-none"
              v-html="dictionary.resultsSendResultsDisclaimer"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as lib from '../../../lib/lib'
import Loader from '../common/Loader.vue'
import Alert from '../common/Alert.vue'
import axios from 'axios'
import useVuelidate from '@vuelidate/core'
import { email, required } from '@vuelidate/validators'
import WizardResultsProfile from './WizardResultsProfile.vue'
import WizardResultsPlan from './WizardResultsPlan.vue'
import WizardResultsSuggestion from './WizardResultsSuggestion.vue'

export default {
  components: {
    Alert,
    Loader,
    WizardResultsProfile,
    WizardResultsPlan,
    WizardResultsSuggestion,
  },

  props: {
    results: {
      required: true,
      type: Object,
    },
  },
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      isLoading: false,
      errorMsgs: [],
      showResponse: false,

      scrollOffsetY: 160,

      // results: [],
      interval: 1,
      rate: 1,

      mark: (val) => ({
        label: `${val}%`,
        labelStyle: {
          fontSize: '24px',
          lineHeight: '30px',
          fontWeight: 400,
        },
      }),

      sliderOptions: {
        lazy: true,
        duration: null,
        height: 7,
        contained: true,
      },

      selectedValue: 4,

      minValue: 2,
      maxValue: 6,

      email: '',
      terms: false,
      subscription: false,
    }
  },
  validations() {
    return {
      email: { required, email },
      terms: { sameAs: (val) => val === true },
    }
  },
  mounted() {
    // console.log('results', this.results)
    // this.getResults()
  },
  methods: {
    async callCaptcha() {
      /* eslint-disable no-undef */

      return new Promise((resolve, reject) => {
        const fetchAsyncData = async () => {
          try {
            const result = await grecaptcha.execute(
              this.configuration.reCaptchaPublicKey,
              {
                action: this.configuration.action,
              }
            )
            resolve(result)
          } catch (error) {
            reject(error)
          }
        }

        fetchAsyncData()
      })

      /* eslint-enable no-alert, no-console */
    },

    async onSubmitForm() {
      this.v$.$validate()

      const captchaToken = await this.callCaptcha()
      const formData = new FormData()

      if (!captchaToken) return

      if (this.v$.$invalid) {
        this.$nextTick(() => {
          lib.scrollToValidation(this.scrollOffsetY)
        })
        return false
      }

      this.isLoading = true

      formData.append('email', this.email)
      formData.append('terms', this.terms)
      formData.append('subscription', this.subscription)
      formData.append('__RequestVerificationToken', this.configuration.token)
      formData.append('captchaTokenResponse', captchaToken)
      formData.append('sessionId', this.configuration.sessionId)

      axios
        .post(this.configuration.endpointSendResults, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Requested-With': 'XMLHttpRequest',
          },
        })
        .then((response) => {
          const { hasError, errorMessages } = response.data
          // response has error
          if (hasError) {
            this.handleError(errorMessages)
            return false
          }
          this.handleSuccess()
        })
        .catch((errors) => {
          this.handleError([this.dictionary.defaultErrorMessage])
          console.error(errors)
        })
    },

    handleSuccess() {
      this.errorMsgs = []
      this.isLoading = false
      this.showResponse = true
      this.resetForm()

      this.v$.$reset()
    },

    handleError(messages) {
      this.errorMsgs = messages
      this.isLoading = this.showResponse = false
    },

    resetForm() {
      this.email = ''
    },
  },
}
</script>
